import React from 'react';

interface VideoPlayerProps {
    component: any;
    value: any;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ component, value }) => {
    const { dataFrom, url, videoType, customStyle } = component;

    let videoSrc = '';
    if (dataFrom === 'url') {
        videoSrc = url;
    } else if (dataFrom === 'existValue' && value) {
        // Assuming value is the URL string
        videoSrc = value;
    }

    // Fallback if value is passed directly and dataFrom is ambiguous
    if (!videoSrc && value && typeof value === 'string') {
        videoSrc = value;
    }

    if (!videoSrc) {
        return <div className="text-gray-400 p-4 border border-dashed rounded text-center">No Video Source</div>;
    }

    return (
        <div className="w-full flex justify-center bg-black rounded overflow-hidden">
            <video
                controls
                className="max-w-full max-h-[500px]"
                style={customStyle ? parseStyle(customStyle) : {}}
            >
                <source src={videoSrc} type={videoType || 'video/mp4'} />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

const parseStyle = (styleStr: string) => {
    const style: any = {};
    if (!styleStr) return style;
    styleStr.split(';').forEach(rule => {
        const [key, val] = rule.split(':');
        if (key && val) {
            style[key.trim()] = val.trim();
        }
    });
    return style;
}

export default VideoPlayer;
